// 简单的 HTTP 客户端，用于非 RTK Query 的 API 调用
const BASE_URL = process.env.API_BASE_URL || '/api';
async function request(endpoint, config = {}) {
    const { method = 'GET', headers = {}, body } = config;
    const url = `${BASE_URL}${endpoint}`;
    const requestHeaders = {
        'Content-Type': 'application/json',
        ...headers,
    };
    // 从 localStorage 获取 token（如果有）
    const token = localStorage.getItem('token');
    if (token) {
        requestHeaders['Authorization'] = `Bearer ${token}`;
    }
    const requestConfig = {
        method,
        headers: requestHeaders,
    };
    if (body && method !== 'GET') {
        requestConfig.body = JSON.stringify(body);
    }
    try {
        const response = await fetch(url, requestConfig);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: response.statusText }));
            throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
        }
        const data = await response.json();
        return { data };
    }
    catch (error) {
        console.error(`API request failed: ${method} ${endpoint}`, error);
        throw error;
    }
}
export const apiClient = {
    get: (endpoint, headers) => request(endpoint, { method: 'GET', headers }),
    post: (endpoint, body, headers) => request(endpoint, { method: 'POST', body, headers }),
    put: (endpoint, body, headers) => request(endpoint, { method: 'PUT', body, headers }),
    delete: (endpoint, headers) => request(endpoint, { method: 'DELETE', headers }),
    patch: (endpoint, body, headers) => request(endpoint, { method: 'PATCH', body, headers }),
};
